import React from 'react';
import { Field, reduxForm } from 'redux-form';
import classNames from 'classnames';
import { renderField } from '../../../Utils/renderField/renderField';
import { generateRandomPassword } from '../utils';


const renderPassword = (props) => {
    const {
        input,
        meta: { touched, error },
    } = props;

    const generateRandPass = () => {
        const randomPassword = generateRandomPassword();
        input.onChange(randomPassword);
    }

    const invalid = touched && error;

    return (
        <div className="input-group mb-3">
            <input
                type="text"
                aria-label="New Temporary Password"
                aria-describedby="password-generate"
                {...input}
                className={classNames("form-control", {
                    "is-invalid": invalid,
                })}
            />
            <div className="input-group-append">
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{ borderColor: "#ced4da" }}
                    id="password-generate"
                    onClick={generateRandPass}
                >
                    <i className="fa fa-random mr-1" />
                    <span className="h6 mb-0 ml-1 fw-600">
                        Generate
                    </span>
                </button>
            </div>
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    )
}

const Form = (props) => {
    const {
        handleSubmit,
        onCancel,
        showBtns = true,
        id,
    } = props;

    return (
        <form onSubmit={handleSubmit} id={id} className="d-flex flex-wrap">
            <div className="col-12">
                <div className="form-group">
                    <label htmlFor="username" className="h6 fw-600">
                        Username
                    </label>
                    <Field
                        name="username"
                        component={renderField}
                        disabled
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="username" className="h6 fw-600">
                        New Temporary Password<span className="text-primary ml-1">*</span>
                    </label>
                    <Field
                        name="password"
                        component={renderPassword}
                        placeholder="Enter temporary password"
                    />
                </div>
                <div className="alert alert-info d-flex" style={{ backgroundColor: "#e8f4fd" }}>
                    <i className="fa fa-info-circle mt-1" />
                    <span className="flex-1 ml-2"
                        style={{ fontSize: "95%", lineHeight: 1.5 }}
                    >
                        This will set a temporary password for the user. They will be <strong>required to change it</strong> on their next login.
                    </span>
                </div>
            </div>
            {showBtns && (
                <div className="col-12 d-flex justify-content-end">
                    <button type="button"
                        className="btn btn-outline-secondary m-1"
                        onClick={onCancel}
                    >
                        <span className="fw-600">
                            Cancel
                        </span>
                    </button>
                    <button type="submit" className="btn btn-warning m-1">
                        <i className="fa fa-key mr-1" />
                        <span className="fw-600">
                            Confirm Reset
                        </span>
                    </button>
                </div>
            )}
        </form>
    )
}

export default reduxForm({
    form: "driver-reset-password",
    validate: (data) => {
        const errors = {};
        if (!data.username) errors.username = "Required Field";
        if (!data.password) errors.password = "Required Field";
        return errors;
    }
})(Form);
